<template>
    <v-layout wrap>
        <v-flex xs12>
            <v-switch
                    :disabled="readonly"
                    v-model="required"
                    :label="required ? 'Requiere control' : 'No requiere control'" />
        </v-flex>
        <v-scroll-y-transition>
            <v-layout wrap v-show="required">
                <v-flex xs6 pa-1>
                    <v-text-field :readonly="readonly" type="number" min="1" v-model="duration" label="Próximo control"/>
                </v-flex>
                <v-flex xs6 pa-1>
                    <v-select :readonly="readonly" :items="units" v-model="durationUnit"  />
                </v-flex>
            </v-layout>
        </v-scroll-y-transition>

    </v-layout>
</template>
<script>

    import {ApiUtils} from '@/utils/ApiUtils'
    import {debounce} from '@/utils/Common'
    import {mapMutations, mapState} from 'vuex'

    export default{
        props: ['control', 'readonly', 'eventId'],
        data(vm){
            return {
                required: vm.control && Boolean(vm.control.required) || false,
                duration: vm.control && vm.control.duration || 1,
                durationUnit: vm.control && vm.control.duration_unit || 'days'
            }
        },
        methods: {
                ...mapMutations(['showSnackBar']),
            async setControl(){

                var vm = this
                if(!vm.currentProvider) {
                    return
                }

                const response = await ApiUtils.makePatch(`indications/${vm.currentProvider.id}/control`, null, {
                    schedule_event_id: vm.eventId,
                    required: vm.required ? 1 : 0,
                    duration: vm.duration,
                    duration_unit: vm.durationUnit
                })

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando guardar los datos del control')
                }

                const json = await response.json()
                vm.$emit('update', json.result.control)

            },
            debouncedSetControl: debounce(function () {
                this.setControl()
            }, 1000)
        },
        computed:{
                ...mapState(['currentProvider']),
            units(){
                var vm = this
                return [
                    {
                        text: `día${vm.duration > 1 ? 's' : ''}`,
                        value: 'days'
                    },
                    {
                        text: `semana${vm.duration > 1 ? 's' : ''}`,
                        value: 'weeks'
                    },
                    {
                        text: `mes${vm.duration > 1 ? 'es' : ''}`,
                        value: 'months'
                    },
                    {
                        text: `año${vm.duration > 1 ? 's' : ''}`,
                        value: 'years'
                    },
                ]
            }
        },
        watch:{
            duration(val, oldVal){
                var vm = this
                if(val < 1) vm.duration = oldVal
                vm.$nextTick(function(){
                    if(vm.required) {
                        vm.debouncedSetControl()
                    }
                })
            },
            durationUnit(){
                var vm = this
                if(vm.required) {
                    vm.debouncedSetControl()
                }
            },
            required(val){
                var vm = this
                vm.debouncedSetControl()
            }
        }
    }
</script>